export default function LoadingBar(props: { loading: React.ReactElement }) {
	return props.loading;
}
